import React, { useState, useEffect, useRef } from "react";
import "../common/index.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// CSS
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "./leftSidebar.scss";

// Store & Actions
import store from "../../store";
import {
  addToCart,
  addToCartUnsafe,
  addToWishlist,
  changeRouteName,
  getAllProducts,
  getProductCategory,
} from "../../actions";

import ScrollToTop from "../pages/scroll_to_top";
import ProductDetailsMe from "./productDetailsI";
import EmptySearch from "../../svg_code/emptySearch";
import LoaderSpinner from "../../components/loadingspin";

const normalizeProductSlug = (rawId) => {
  if (!rawId) return "";
  const parts = rawId.split("-");
  const lastPart = parts[parts.length - 1];
  return /^\d+$/.test(lastPart) ? parts.slice(0, -1).join("-") : rawId;
};

function LeftSideBar({
  item,
  pathName,
  shortView,
  CutLoading,
  location,
  // ... other props from connect/withRouter if needed
}) {
  const topRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [nav3, setNav3] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [stock, setStock] = useState("InStock");
  const [loading, setLoading] = useState(true);

  // Helper to get number from query param
  const getNumberFromQuery = (value) => {
    if (!value) return null;
    const num = Number(value);
    return isNaN(num) ? null : num;
  };

  // ── componentDidMount + componentDidUpdate logic ──
  // useEffect(() => {
  //   // Initial setup (like componentDidMount)
  //   setNav1(nav1); // yeh slider refs hain — agar use nahi ho rahe to remove kar sakte ho
  //   setNav2(nav2);
  //   setLoading(true);

  //   const searchParams = new URLSearchParams(location.search);
  //   const categoryPId = item?.category[0]?.category_id || undefined
  //   const productPId = getNumberFromQuery(searchParams.get("product"));
  //   console.log("checkCateIddd", categoryPId)
  //   const categoryId = location?.state?.category_ids || categoryPId || null;
  //   const productId = location?.state?.product_id || productPId || null;

  //   // Dispatch actions
  //   store.dispatch(getAllProducts(categoryId, productId, () => setLoading(false)));
  //   store.dispatch(getProductCategory());
  //   store.dispatch(changeRouteName([{ routeName: pathName }]));

  //   // Smooth scroll to top on mount
  //   if (topRef.current) {
  //     topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }

  //   // Cleanup (not needed here but good practice)
  //   return () => {
  //     // koi cleanup chahiye to yahan likh dena
  //   };
  // }, []); // ← empty dependency = componentDidMount only


  useEffect(() => {
    store.dispatch(getProductCategory());
    store.dispatch(changeRouteName([{ routeName: pathName }]));
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const apiCalled = useRef(false);

  useEffect(() => {
    if (apiCalled.current) return;

    apiCalled.current = true;


    const categoryPId = item?.category?.[0]?.category_id;
    // const productPId = getNumberFromQuery(searchParams.get("product"));
    const path = window.location.pathname;

    const productIdDaches = Number(path.split("-").pop());
    const categoryId = location?.state?.category_ids || categoryPId || null;
    const productId = location?.state?.product_id || productIdDaches || null;

    setLoading(true);

    store.dispatch(getAllProducts(categoryId, productId, () => setLoading(false)));

    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

  }, [item]);

  // Handle pathName / route change → like componentDidUpdate
  useEffect(() => {
    // Jab pathName change ho (URL change)
    store.dispatch(changeRouteName([{ routeName: pathName }]));

    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pathName]); // ← sirf pathName change hone par chalega

  // Quantity handlers
  const minusQty = () => {
    if (quantity > 1) {
      setStock("InStock");
      setQuantity((prev) => prev - 1);
    }
  };

  const plusQty = () => {
    if (item?.stock >= quantity + 1) {
      setQuantity((prev) => prev + 1);
    } else {
      setStock("Out of Stock");
    }
  };

  const changeQty = (e) => {
    setQuantity(parseInt(e.target.value) || 1);
  };

  // Filter sidebar handlers (agar ab bhi use ho rahe hain)
  const filterClick = () => {
    const el = document.getElementById("filter");
    if (el) el.style.left = "-15px";
  };

  const backClick = () => {
    const el = document.getElementById("filter");
    if (el) el.style.left = "-365px";
  };

  // ── Render ──
  return (
    <div>
      {/* Invisible anchor for smooth scroll to top */}
      <div
        ref={topRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "1px",
          width: "1px",
          pointerEvents: "none",
        }}
      />

      {loading ? (
        <div
          className="text-center"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ScrollToTop />
          <LoaderSpinner />
        </div>
      ) : item ? (
        <>
          <ScrollToTop />
          <ProductDetailsMe
            pathName={pathName}
            shortView={shortView}
            item={item}
            CutLoading={CutLoading}
          />
        </>
      ) : (
        <div
          className="text-center"
          style={{
            minHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem",
          }}
        >
          <ScrollToTop />
          <EmptySearch />
          <br />
          <br />
          <h4 className="fw-bold mb-3">Sorry, No Products Found!</h4>
          <p className="text-muted">
            The product you're looking for might have been removed or is
            temporarily unavailable.
          </p>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  let productasdId = ownProps?.url
    ? ownProps?.url
    : ownProps?.match?.params?.id;

  const productId = normalizeProductSlug(productasdId);

  const productsData = state?.data?.products?.data || [];

  return {
    pathName: productId,
    item: productsData.find((el) => el?.api?.url_key === productId) || null,
    symbol: state?.data?.symbol,
    review: state?.data?.reviewsdata?.data || [],
    shortView: ownProps?.url ? true : false,
  };
};

export default connect(mapStateToProps, {
  addToCart,
  addToCartUnsafe,
  addToWishlist,
})(withRouter(LeftSideBar));
